import { useContext, useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useLogout } from './Auth.hooks';
import { clearPersistStorage } from '@services/query-client/QueryClient';
import { AppContext } from '../../../App.context';

export function Logout() {
	const navigate = useNavigate();
	const { clearCache } = useContext(AppContext);
	const isLoading = useLogout();
	useEffect(() => {
		if (!isLoading) {
			const promises: Array<Promise<any>> = [clearPersistStorage()];
			if (clearCache) {
				promises.push(clearCache);
			}
			Promise.all(promises)
				.then(() => {
					navigate({
						to: '/',
						replace: true,
					});
				})
				.catch(() => {
					navigate({
						to: '/',
						replace: true,
					});
				});
		}
	}, [isLoading]);
	return <div />;
}
